import { render, staticRenderFns } from "./dropzone.vue?vue&type=template&id=7ed6b410&scoped=true&lang=html&"
import script from "./dropzone.vue?vue&type=script&lang=js&"
export * from "./dropzone.vue?vue&type=script&lang=js&"
import style0 from "./dropzone.vue?vue&type=style&index=0&id=7ed6b410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed6b410",
  null
  
)

export default component.exports